import { api, handleResponse, handleError } from "./apiUtils";
import {
  GET_FREE_APPOINTMENTS,
  CREATE_APPOINTMENT,
  GET_BUSY_DAYS,
} from "../global/Constants/appointment";

export function createAppointment(appointment) {
  let data = Object.assign({}, appointment);
  return fetch(CREATE_APPOINTMENT, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Session_Id: localStorage.getItem("Session_Id"),
    },
    body: JSON.stringify(data),
  })
    .then((response) => {
      if (!response.ok) {
        throw new Error(`Ошибка: ${response.statusText}`);
      }
      return response.json(); // Парсим JSON из ответа
    })
    .then((data) => {
      console.log(data); // Ответ от сервера
    })
    .catch(handleError); // Обработка ошибок
}

export function getFreeAppointments(data) {
  // Преобразуем дату в формат yyyy-MM-dd
  const formattedDate = formatDate(data.date);

  // Кодируем параметры для URL
  const dateParam = encodeURIComponent(formattedDate);
  const doctorIdParam = encodeURIComponent(data.doctorId);
  const phoneParam = encodeURIComponent(data.phone);
  const checkCurrentDateParam = encodeURIComponent(data.checkCurrentDate);

  return api
    .get(
      `${GET_FREE_APPOINTMENTS}?date=${dateParam}&doctorId=${doctorIdParam}&phone=${phoneParam}&checkCurrentDate=${checkCurrentDateParam}`
    )
    .then(handleResponse)
    .catch(handleError);
}

// Функция для преобразования даты в формат yyyy-MM-dd
function formatDate(date) {
  const d = new Date(date);
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, "0"); // Месяц от 0 до 11, добавляем 1 и добавляем ведущий ноль
  const day = String(d.getDate()).padStart(2, "0"); // Делаем день с ведущим нулем

  return `${year}-${month}-${day}`;
}

export function getBusyDays(data) {
  return api
    .get(
      `${GET_BUSY_DAYS}?month=${data.month}&year=${data.year}&doctorId=${data.doctorId}`
    )
    .then(handleResponse)
    .catch(handleError);
}
